import { Chip } from '@mui/material';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type Props = {
  label: string;
  onClose?: () => void;
  onClick?: () => void;
  selected?: boolean;
};

export const FilterPill = ({ label, onClose, onClick, selected }: Props) => {
  return (
    <Chip
      variant="outlined"
      size="small"
      label={label}
      onClick={onClick}
      onDelete={onClose}
      icon={
        selected ? <CheckCircleIcon fontSize="small" /> : <PanoramaFishEyeIcon fontSize="small" />
      }
    />
  );
};
